/**
 * GeoJSON import target: when a polygon is already in context, the wizard
 * must not offer a polygon picker (including „Nové“).
 */

export function isGeojsonImportPolygonPickerEnabled(
  lockPolygonId?: string | null,
): boolean {
  return !String(lockPolygonId ?? '').trim();
}
